import { useState } from "react";

function DateOfBirthSection({ day, setDay, month, setMonth, year, setYear }) {
  const [isEditing, setIsEditing] = useState(false);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleSave = () => {
    setIsEditing(false);
    //console.log(`Selected date: ${day}/${month}/${year}`);
  };

  const handleDayChange = (event) => {
    setDay(event.target.value);
  };

  const handleMonthChange = (event) => {
    setMonth(event.target.value);
  };

  const handleYearChange = (event) => {
    setYear(event.target.value);
  };

  return (
    <div className="mb-4">
      <h2 className="font-bold text-gray-700 text-lg mb-2">Date of Birth</h2>
      {!isEditing ? (
        <div>
          <p className="text-gray-500 text-sm">{`${day}/${month}/${year}`}</p>
          <button
            className="text-blue-500 hover:text-blue-700 text-sm"
            onClick={handleEdit}
          >
            Edit
          </button>
        </div>
      ) : (
        <div>
          <label className="block text-gray-700 font-bold mb-2">
            Date of birth*
          </label>
          <div className="flex">
            <input
              className="w-1/3 border-gray-300 rounded-md shadow-sm mb-2 mr-2"
              type="text"
              placeholder="DD"
              value={day}
              onChange={handleDayChange}
            />
            <input
              className="w-1/3 border-gray-300 rounded-md shadow-sm mb-2 mr-2"
              type="text"
              placeholder="Month"
              value={month}
              onChange={handleMonthChange}
            />
            <input
              className="w-1/3 border-gray-300 rounded-md shadow-sm mb-2"
              type="text"
              placeholder="YYYY"
              value={year}
              onChange={handleYearChange}
            />
          </div>
          <div className="mt-4">
            <button
              className="text-white bg-black hover:scale-[1.05] transition-all font-bold py-2 px-4 mr-2"
              onClick={handleSave}
            >
              Save
            </button>
            <button
              className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4"
              onClick={handleCancel}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default DateOfBirthSection;
